import React from 'react'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FilledInput from '@material-ui/core/FilledInput'
import Select from '@material-ui/core/Select'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'
import Checkbox from '@material-ui/core/Checkbox'
import { getProductString } from 'config/helpers/Helpers'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  	PaperProps: {
    	style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
    	},
  	},
};

function ProductSelect({
    products,
    updateProducts,
    productsAvailable,
    inputVariant = 'outlined', // 'outlined' | 'filled'
    showAll = true,
    placeholder = ''
}) {
    function handleUpdate(selected) {
        if (showAll && selected.indexOf('All') > -1) {
            selected = ['All']
        }
        updateProducts(selected)
    }

    const inputComponent = inputVariant === 'filled' ? <FilledInput disableUnderline /> : <OutlinedInput />

    // normalize productsAvailable to array of {value,label}
    let optionsArray = []
    if (Array.isArray(productsAvailable)) {
        optionsArray = productsAvailable
    } else if (productsAvailable && typeof productsAvailable === 'object') {
        optionsArray = Object.keys(productsAvailable).map(k => ({ value: k, label: getProductString(k) }))
    }

    return (
        <Select
            multiple
            value={products}
            onChange={(e) => handleUpdate(e.target.value)}
            displayEmpty
            renderValue={(selected) => {
                if (selected.length === 0) {
                    return <span style={{ color: '#8898aa', opacity: 0.5 }}>{placeholder || ''}</span>
                }
                if (showAll && selected[0] === 'All') return 'All'
                return selected.map(p => getProductString(p)).join(', ')
            }}
            MenuProps={MenuProps}
            input={inputComponent}
            placeholder={placeholder}
        >
            {showAll && (
                <MenuItem value={'All'} key={'all'}>
                    <Checkbox checked={products.indexOf('All') > -1} color='primary' />
                    <ListItemText primary='All' className='checkbox-menu-item' />
                </MenuItem>
            )}
            {optionsArray.map((option, i) => (
                <MenuItem
                    value={option.value}
                    key={i}
                    disabled={showAll && products.indexOf('All') > -1 && option.value !== 'All'}
                >
                    <Checkbox checked={products.indexOf(option.value) > -1} color='primary' />
                    <ListItemText primary={option.label} className='checkbox-menu-item' />
                </MenuItem>
            ))}
        </Select>
    )
}

export default ProductSelect